import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  grid-area: buyer;
  padding: 1rem 0 0 1rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default ({ children: buyer }) => <Container>@{buyer}</Container>;
